import { useState } from "react";

import {
  sendChangeCar,
  videoMixPat,
  vehicleChangeSelectCar,
  sendUpdateScreen,
} from "../../../../../utils/sendData";
import { Vehicle, ObserveRefreshData } from "../../../../../types/observe";
import ConfirmModal from "../../../../../components/confirmModal/ConfirmModal";

import "./VehicleSelect.scss";

interface VehicleSelectProps {
  layoutId: number;
  vehicle: Vehicle | null;
  selectableVehicles: Vehicle[];
  refreshData: ObserveRefreshData | null;
  monitorConsoleId: number | null;
  observeCC: string | null;
  onevehicleCC: string | null;
  sendData: (msg: object) => void;
  onReconnectJanus: (
    vehicleId: number,
    action: "connect" | "disconnect"
  ) => void;
  isAnyRemoteMode?: boolean;
}

const VehicleSelect = ({
  layoutId,
  vehicle,
  selectableVehicles,
  refreshData,
  monitorConsoleId,
  observeCC,
  onevehicleCC,
  sendData,
  onReconnectJanus,
  isAnyRemoteMode = false,
}: VehicleSelectProps) => {
  const sr = observeCC;
  const dt = vehicle?.vehicle_communication_code;
  const VIDEO_SELECT1 = 1;
  const COMM_CTLI_CAR_CTR = 1;

  const [selectedVehicleId, setSelectedVehicleId] = useState<string | null>(
    null
  );

  const isSelecting = refreshData?.info?.is_selecting;
  const buttonClassName = [
    "vehicleButton",
    isSelecting === "1"
      ? "selectedByThis"
      : isAnyRemoteMode
      ? "remoteMode"
      : refreshData?.other_selecting
      ? "selectedByOther"
      : refreshData?.drive?.monitor_f == "0"
      ? "noMonitorF"
      : "notSelected",
  ].join(" ");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleVehicleButtonClick = () => {
    if (!sr || !dt || !monitorConsoleId) return;

    sendData(videoMixPat(sr, dt, VIDEO_SELECT1));

    setTimeout(() => {
      sendData(vehicleChangeSelectCar(sr, dt, COMM_CTLI_CAR_CTR));
    }, 300);
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (value !== "") {
      setSelectedVehicleId(value);
      setIsModalOpen(true);
    }
  };

  const handleConfirm = () => {
    if (!sr || !dt || !onevehicleCC || !selectedVehicleId || !monitorConsoleId)
      return;

    let dbcontrolCC = import.meta.env.VITE_DBCONTROL_COMMUNICATION_CODE;
    if (!dbcontrolCC) return;
    dbcontrolCC = sr.slice(0, 4) + dbcontrolCC;

    // ガイド線指示は画面更新指示に統合
    sendData(sendUpdateScreen(sr, onevehicleCC, 2, selectedVehicleId, 0, 0));
    sendData(vehicleChangeSelectCar(sr, dt, 0));
    setTimeout(() => {
      sendData(sendChangeCar(sr, dbcontrolCC, layoutId, selectedVehicleId));

      if (vehicle?.vehicles_vehicle_id && onReconnectJanus) {
        onReconnectJanus(vehicle.vehicles_vehicle_id, "disconnect");
      }

      const selectedVehicle = selectableVehicles.find(
        (v) => v.vehicle_communication_code === selectedVehicleId
      );
      if (selectedVehicle?.vehicles_vehicle_id && onReconnectJanus) {
        onReconnectJanus(selectedVehicle.vehicles_vehicle_id, "connect");
      }
    }, 500);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="vehicleSelect">
        <button
          className={buttonClassName}
          onClick={handleVehicleButtonClick}
          disabled={isAnyRemoteMode}
        >
          <span className="tileNo">{vehicle?.vehicle_no}</span>
          <span>{vehicle?.vehicle_label}</span>
        </button>
        <select
          className="selectBox"
          id={`car_change_${layoutId}`}
          onChange={handleSelectChange}
        >
          <option value="">ー</option>
          {selectableVehicles.map((v) => (
            <option
              key={v.vehicle_communication_code}
              value={`${v.vehicle_communication_code}`}
            >
              {v.vehicle_label}
            </option>
          ))}
        </select>
      </div>
      <ConfirmModal
        isOpen={isModalOpen}
        icon="check"
        message="監視車両の切り替えを実施します。"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
};

export default VehicleSelect;
